import ServiceBase from '../../ServiceBase';
import foreignProxy from '../../../proxies/market/moneyflow/ForeignProxy';
import { ChanelConfig } from './../../../../configs/GlobalConfig';

class ForeignService extends ServiceBase {
  getForeign(params, source) {
    return this.processSubscription(data => {
      var res = [];

      for (var ticker of data.items[0].today.buy) {
        res.push(this.getSubscribtionChannel(ticker.organCode));
      }

      for (var ticker of data.items[0].today.sell) {
        res.push(this.getSubscribtionChannel(ticker.organCode));
      }

      return res;
    })(() =>
      this.applyMemoryCache('ForeignService.getForeign', params)(() =>
        foreignProxy.getForeign(params, source),
      ),
    );
  }
}

const foreignService = new ForeignService();
export default foreignService;
